import { FC } from "react";
import ProgressCircle from "../ProgressCircle";

interface ProgressBarProps {
  activeStep: number;
  totalSteps: number;
  placeholder?: string[];
}

const ProgressBar: FC<ProgressBarProps> = ({
  activeStep,
  totalSteps,
  placeholder,
}) => {
  const activeLineWidth = (100 / (totalSteps - 1)) * (activeStep - 1);
  return (
    <div
      className={
        "mx-auto w-full flex flex-row justify-between relative before:absolute before:bg-nivabupa-gray before:opacity-30 before:h-0.5 before:top-1/2 before:w-full before:-translate-y-1/2 before:left-0 mt-3 md:mt-0 max-w-[90%]"
      }
    >
      <div
        className={
          "absolute h-0.5 top-1/2 -translate-y-1/2 left-0 bg-nivabupa-blue-light"
        }
        style={{ width: `${activeLineWidth}%` }}
      ></div>
      {[...Array(totalSteps).keys()].map((key) => (
        <div key={key}>
          <ProgressCircle
            key={key}
            text={placeholder ? placeholder[key] : ""}
            active={activeStep >= key + 1}
          />
        </div>
      ))}
    </div>
  );
};

export default ProgressBar;
